import * as Api from "../../api";

export function compareContent(
  d: Api.Server.ContentEntityOutput | undefined | null,
  n: Api.Server.ContentEntityOutput | undefined | null
): boolean {
  if (d === n) {
    return true;
  }

  if (!d || !n) {
    return false;
  }

  return (
    d.id === n.id &&
    d.title === n.title &&
    arraysEqual(d.parameters, n.parameters, (p1, p2) => p1.value == p2.value) &&
    arraysEqual(d.authors, n.authors, (a, b) => a == b) &&
    arraysEqual(d.plans, n.plans, (a, b) => a == b) &&
    arraysEqual(
      d.authorsOriginalNames,
      n.authorsOriginalNames,
      (a, b) => a == b
    ) &&
    d.chaptersCount === n.chaptersCount &&
    d.durationMS === n.durationMS &&
    d.originalTitle === n.originalTitle &&
    d.originalSubTitle === n.originalSubTitle &&
    d.rate === n.rate &&
    d.actualCost === n.actualCost &&
    d.actualDurationMS === n.actualDurationMS
  );
}

export function compareComponent(
  d: Api.Server.ComponentWithUniqueIdOutput | undefined,
  n: Api.Server.ComponentWithUniqueIdOutput | undefined
): boolean {
  return (
    d === n ||
    (d != undefined &&
      n != undefined &&
      d.id === n.id &&
      d.uniqueId === n.uniqueId &&
      // compare parameters deeply
      deepEqual(d.parameters, n.parameters))
  );
}

function deepEqual<T>(a: T, b: T): boolean {
  if (a === b) {
    return true;
  }

  if (
    typeof a !== "object" ||
    a === null ||
    typeof b !== "object" ||
    b === null
  ) {
    return false;
  }

  const keysA = Object.keys(a) as [keyof T];
  const keysB = Object.keys(b) as [keyof T];

  if (keysA.length !== keysB.length) {
    return false;
  }

  for (const key of keysA) {
    if (!keysB.includes(key) || !deepEqual(a[key], b[key])) {
      return false;
    }
  }

  return true;
}

function arraysEqual<T>(
  arr1: T[] | undefined,
  arr2: T[] | undefined,
  comparator?: (a: T, b: T) => boolean
): boolean {
  if (arr1 === arr2) {
    return true;
  }

  if (!arr1 || !arr2 || arr1.length !== arr2.length) {
    return false;
  }

  if (!comparator) {
    return JSON.stringify(arr1) === JSON.stringify(arr2);
  }

  for (let i = 0; i < arr1.length; i++) {
    if (!comparator(arr1[i], arr2[i])) {
      return false;
    }
  }

  return true;
}
